export default function TrainingWebinarController(
  $q,
  $window,
  ssDialogService,
  viewWebinarDialog,
  utilityService,
  eduDataService
) {
  const vm = this;
  const webinarWidth = 900;
  const webinarHeight = 600;

  vm.handleViewWebinarClick = _handleViewWebinarClick;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.media.thumbnailUrl = utilityService.sanitizeImageSrc(vm.media.thumbnailUrl);
  }

  function _handleViewWebinarClick($event) {    

    if (vm.media.isWebPage) {
      $window.open(vm.media.mediaUrl, '_blank');
    } else { 
      eduDataService.logMediaActivity(vm.media.mediaId);
      ssDialogService.dialogs.support.viewWebinarDialog = ssDialogService.alert(
        viewWebinarDialog.getOptions($event, {
          mediaUrl: vm.media.mediaUrl,
          webinarHeight,
          webinarWidth,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.support.viewWebinarDialog);
    }
  }
}

TrainingWebinarController.$inject = [
  '$q',
  '$window',
  'ssDialogService',
  'viewWebinarDialog',
  'utilityService',
  'eduDataService'
];
